import { mountMasthead } from './js/wireframe-masthead.js';
import * as scenes from './js/research-chapter-scenes.js';
import chapterList from './data/work-chapters.json';
import { workTitleRows } from './js/masthead-title.js';
const chapters = Object.fromEntries(chapterList.map(chapter => [chapter.id,chapter]));

// Only the illustration fades; the Lufga title keeps its solid silhouette.
// This is scoped to chapter SVGs and does not change the homepage renderer.
function addChapterFade(hero, id) {
    const ns = 'http://www.w3.org/2000/svg';
    const element = (tag, attributes) => {
        const node = document.createElementNS(ns, tag);
        for (const [key, value] of Object.entries(attributes)) node.setAttribute(key, value);
        return node;
    };
    const svg = hero.querySelector('svg'), defs = svg.querySelector('defs');
    const gradient = element('linearGradient', { id: `${id}-depth-fade`, x1: 0, y1: 0, x2: 0, y2: 1 });
    for (const [offset, opacity] of [[0,.12],[.08,.72],[.18,1],[.82,1],[.94,.72],[1,.12]]) {
        gradient.append(element('stop', { offset, 'stop-color': '#fff', 'stop-opacity': opacity }));
    }
    const mask = element('mask', {
        id: `${id}-depth-mask`, x: 0, y: 0, width: 1, height: 1,
        maskUnits: 'objectBoundingBox', maskContentUnits: 'objectBoundingBox',
        'mask-type': 'alpha',
    });
    mask.append(element('rect', { width: 1, height: 1, fill: `url(#${id}-depth-fade)` }));
    defs.append(gradient, mask);
    for (const path of svg.querySelectorAll('.research-hero-wires, .research-hero-overlap')) {
        path.setAttribute('mask', `url(#${id}-depth-mask)`);
    }
}

function mountResearchHeaders() {
const cleanup = [];
const resume = document.querySelector('body.research-highlights .resume:not(.layout-comparison)');
if (resume) {
    for (const hero of resume.querySelectorAll('[data-chapter]')) {
        const id = hero.dataset.chapter, chapter = chapters[id];
        if (!chapter || hero.closest('[data-print-only]')) continue;
        const title = chapter.rows;
        const heading = resume.querySelector('.research-gallery-title');
        if (heading) heading.textContent = chapter.title;
        cleanup.push(mountMasthead(hero, {
            id: `${id}-hero`,
            caption: chapter.caption,
            centerTitle: true,
            titleRows: small => workTitleRows(title, small),
            viewBox: small => small ? '0 0 760 600' : '0 0 1200 460',
            scene: scenes[chapter.scene](),
        }));
        addChapterFade(hero, `${id}-hero`);
    }
}

return () => cleanup.forEach(dispose => dispose());
}
let disposeHeaders = mountResearchHeaders();
document.addEventListener("research:before-swap", () => disposeHeaders());
document.addEventListener("research:after-swap", () => { disposeHeaders = mountResearchHeaders(); });
